import Address from './Address';
import Role from '../../shared/models/Role';

export default class Entity {
  public id: string
  public nxtPortId: string
  public name: string
  public vat: string
  public duns: string
  public eori: string
  public referralCode: string
  public dateAdded: string
  public roles: Role[]
  public addresses: Address[]
  public isSingleUserEntity: boolean
}



// WEBPACK FOOTER //
// ./src/modules/organization/models/Entity.ts